<template>
  <div class="outline-button-container" v-bind:class="rootClassName">
    <button class="outline-button-button button">{{ button1 }}</button>
  </div>
</template>

<script>
export default {
  name: 'OutlineButton',
  props: {
    button1: {
      type: String,
      default: 'Button',
    },
    rootClassName: String,
  },
}
</script>

<style scoped>
.outline-button-container {
  display: flex;
  position: relative;
}
.outline-button-button {
  color: var(--dl-color-gray-black);
  padding-top: var(--dl-space-space-unit);
  border-color: var(--dl-color-primary-100);
  border-width: 1px;
  padding-left: var(--dl-space-space-doubleunit);
  border-radius: 50px;
  padding-right: var(--dl-space-space-doubleunit);
  padding-bottom: var(--dl-space-space-unit);
  background-color: var(--dl-color-gray-white);
}
.outline-button-root-class-name {
  align-self: flex-end;
}




</style>
